import moment from 'moment'

export default {
    methods: {
        async getFiltrar() {
            await this.getDataGet({ route: 'get_nominas', data: { others: [] } })
                // frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
        },
        async watchAfiliado() {
            let getBackend = await this.getData({ route: 'ficha_afiliado_get', data: this.searchSw.value })
            const await1 = this.updateDataForm({ state: 'datos_afiliado', data: getBackend.datos_afiliado })
            const await2 = this.updateDataForm({ state: 'info_afiliacion', data: getBackend.info_afiliacion })
            await await1
            await await2
            const await3 = this.updateDataForm({ state: 'info_nomina/name', data: getBackend.datos_afiliado.name })
            const await4 = this.updateDataForm({ state: 'info_nomina/id_list_tipo', data: getBackend.datos_afiliado.id_list_tipo })
            const await5 = this.updateDataForm({ state: 'info_nomina/documento', data: getBackend.datos_afiliado.documento })
            const await6 = this.updateDataForm({ state: 'info_nomina/cargo', data: getBackend.info_afiliacion.cargo })
            const await7 = this.updateDataForm({ state: 'info_nomina/salario', data: getBackend.info_afiliacion.salariobase })
            const await8 = this.updateDataForm({ state: 'info_nomina/id_datos_razon', data: getBackend.info_afiliacion.id_datos_razon })
            const await9 = this.updateDataForm({ state: 'info_nomina/id_datos_afiliado', data: getBackend.datos_afiliado.id })
            await await3
            await await4
            await await5
            await await6
            await await7
            await await8
            await await9

        },
        limpiarAfiliado() {
            this.searchSw.value = ''
            this.resetDataForm()
            this.updateDataForm({ state: 'info_nomina/fecha', data: this.fecha().fecha.minHoy })
        },
        changeValues() {
            if (this.dataForm.afiliado_nomina.info_nomina.fechaini !== null && this.dataForm.afiliado_nomina.info_nomina.fechaini && this.dataForm.afiliado_nomina.info_nomina.fechafin && this.dataForm.afiliado_nomina.info_nomina.fechafin !== this.ultimoFin) {
                let fechaini = this.dataForm.afiliado_nomina.info_nomina.fechaini
                let fechafin = this.dataForm.afiliado_nomina.info_nomina.fechafin
                var dias = moment(fechafin).diff(moment(fechaini), 'days')
                dias = dias + 1

                for (let i = 0; i < this.dataForm.afiliado_nomina.nomina_devengados.length; i++) {
                    if (this.dataForm.afiliado_nomina.nomina_devengados[i].predeterminado !== undefined && this.dataForm.afiliado_nomina.nomina_devengados[i].predeterminado > 0) {
                        let value = (this.dataForm.afiliado_nomina.nomina_devengados[i].predeterminado / 30) * dias
                        this.updateDataForm({ state: 'nomina_devengados/' + i + '/valor', data: value })
                    }
                }
                for (let i = 0; i < this.dataForm.afiliado_nomina.nomina_deducidos.length; i++) {
                    if (this.dataForm.afiliado_nomina.nomina_deducidos[i].predeterminado !== undefined && this.dataForm.afiliado_nomina.nomina_deducidos[i].predeterminado > 0) {
                        let value = (this.dataForm.afiliado_nomina.nomina_deducidos[i].predeterminado / 30) * dias
                        this.updateDataForm({ state: 'nomina_deducidos/' + i + '/valor', data: value })
                    }
                }
                this.ultimoFin = fechafin
            }
        }
    },
}